import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const ConstrainedImage = ({
  src,
  alt,
  className,
  imageClassName,
  defaultWidth = 80,
  defaultHeight = 40,
  constrainedHeight = false,
}) => {
  const [dimensions, setDimensions] = useState(null);

  const handleLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setDimensions({ width: naturalWidth, height: naturalHeight });
  };

  const w = dimensions?.width ?? defaultWidth;
  const h = dimensions?.height ?? defaultHeight;

  return (
    <div
      className={classNames(
        'ConstrainedImage',
        constrainedHeight && 'ConstrainedImage--constrainedHeight',
        className
      )}
      style={
        constrainedHeight
          ? { height: defaultHeight }
          : { width: defaultWidth, height: defaultHeight }
      }
    >
      <img
        className={classNames('ConstrainedImage__image', imageClassName)}
        src={src}
        alt={alt}
        width={w}
        height={h}
        onLoad={handleLoad}
      />
    </div>
  );
};

ConstrainedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  defaultWidth: PropTypes.number,
  defaultHeight: PropTypes.number,
  constrainedHeight: PropTypes.bool,
};

export default ConstrainedImage;
